import Card from './card';
import { CardBox } from './style';

import { useCoursesEnrollment } from 'src/helpers/use';
import { ICategory, ICourse } from 'src/interfaces';

type Props = {
  courses: ICourse[] | undefined;
  learningPathId?: number;
  learningPathCategory?: ICategory;
  courseCount?: number;
};

const CoursesCard = ({ courses, learningPathId, learningPathCategory, courseCount }: Props) => {
  const { coursesData } = useCoursesEnrollment(courses as ICourse[]);

  return (
    <CardBox>
      {coursesData?.map((course) => (
        <Card
          key={`course-${course.id}`}
          course={course}
          learningPathId={learningPathId}
          learningPathCategory={learningPathCategory}
          courseCount={courseCount}
        />
      ))}
    </CardBox>
  );
};

export default CoursesCard;
